import { makeStyles } from '@material-ui/styles'

import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  modal: {
    maxWidth: '900px',
  },
  wrapper: {
    gap: '10px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '10px',
    fontSize: '14px',
  },
  modalContent: {
    width: '100%',
    height: '300px',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '20px',
    paddingBottom: 0,
    fontSize: spacing(14),
  },
  inputPropStyle: {
    fontSize: '14px',
  },
  modalActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: spacing(12),
    margin: spacing(12),
  },
  label: {
    color: Theme.Colors.Grayscale.SixtyFour,
    fontSize: spacing(14),
    marginBottom: spacing(4),
  },
}))
